<template>
  <page-layout :title="categoryData.categoryNm">
    <template v-slot:table>
      <v-container class="board-layout px-3">
        <div class="route-board-category-table px-2">
          <v-btn class="button" outlined @click="routePage('main')">게시판 메인 이동</v-btn>
        </div>
        <div class="board-list-layout">
          <template v-if="deviceWidth < 768">
            <v-container class="board-card-container">
              <v-card class="board-card" v-for="(item, index) in paginatedItems" :key="index"  @click="showBoardDetail(item)">
                <v-card-title class="board-card-title">
                  <span
                      class="board-card-category"
                      :class="{
                      'all-notice': item.noticeLevel === 3,
                      'type-notice': item.noticeLevel === 2
                    }"
                      v-if="item.noticeLevel !== 1"
                  >
                    공지
                  </span>
                  <strong>{{ overLengthText(item.title, titleMaxLength) }}</strong>
                </v-card-title>
                <v-row class="board-card-detail-layout">
                  <v-col class="board-card-details">
                    <span>게시자 : {{ item.createNm }}</span>
                    <span>게시일 : {{ setTableDateFormat(item.createDate) }}</span>
                    <span>조회수 : {{ item.viewCnt }}</span>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </template>
          <template v-else>
          <ul class="board-list-header-container">
            <li class="board-list-header">글번호</li>
            <li class="board-list-header">타이틀</li>
            <li class="board-list-header">게시일</li>
            <li class="board-list-header">게시자</li>
            <li class="board-list-header">조회수</li>
          </ul>
          <ul
              class="board-list"
              :class="{
                'all-notice': item.noticeLevel === 3,
                'type-notice': item.noticeLevel === 2,
                'normal-notice': item.noticeLevel === 1,
                'none-notice': item.title === ''
              }"
              v-for="(item, index) in paginatedItems" :key="index"
              @click="showBoardDetail(item)"
          >
            <li class="board">{{ item.boardId }}</li>
            <li
              class="board"
              :class="{
                'all': item.noticeLevel === 3,
                'type': item.noticeLevel === 2,
                'normal': item.noticeLevel === 1,
              }"
            >
              {{ overLengthText(item.title, titleMaxLength) }}
            </li>
            <li class="board">{{ setDotsDate(item.createDate) }}</li>
            <li class="board">{{ item.createNm }}</li>
            <li class="board">{{ item.viewCnt }}</li>
          </ul>
        </template>
        </div>
        <v-footer class="board-bottom-layout">
          <div class="board-pagination">
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              :total-visible="5"
              @input="onPageChange"
            >
            </v-pagination>
          </div>
          <div class="board-bottom">
            <div class="title-select">
              <v-select
                  v-model="searchType"
                  :items="searchTypeList"
                  item-text="text"
                  item-value="value"
                  outlined hide-details dense
                  background-color="white"
              />
            </div>
            <div class="search-content">
              <v-text-field
                  v-model="searchNm"
                  placeholder="검색어를 입력하세요"
                  outlined hide-details dense
                  background-color="white"
                  append-icon="search"
                  @keydown.enter="getSearchBoardTableList"
                  @click:append="getSearchBoardTableList"
              />
            </div>
            <v-btn v-if="isWriter" class="board-write button save" outlined @click="routePage('write')">글쓰기</v-btn>
          </div>
        </v-footer>
      </v-container>
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import router from "@/router";
import DateMixin from "@/mixin/DateMixin";
import {mapGetters} from "vuex";
import {axiosInstance} from "@/util/AxiosModule";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "BoardTable",
  components: {PageLayout},
  mixins: [DateMixin, TableMixin],
  data() {
    return {
      categoryData: {},
      boardData: {},
      pageBoardList: [],
      itemsPerPage: 12,
      currentPage: 1,
      searchType: "ALL",
      searchTypeList: [
        { text: "전체", value: "ALL" },
        { text: "제목", value: "TITLE" },
        { text: "내용", value: "CONTENT" },
        { text: "글번호", value: "NO" }
      ],
      searchNm: "",
      deviceWidth: 0,
      titleMaxLength: 0
    }
  },
  computed: {
    ...mapGetters("login", {memberRole: "memberRole"}),
    isWriter() {
      if (this.categoryData.useRole === "MANAGER") {
        return this.memberRole === "MANAGER" || this.memberRole === "ADMIN";
      } else {
        return this.memberRole === "ADMIN";
      }
    },
    pageCount() {
      return Math.ceil(this.pageBoardList.length / this.itemsPerPage);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.pageBoardList.slice(start, end);
    }
  },
  async mounted() {
    this.categoryData = JSON.parse(sessionStorage.getItem("boardDetailList"));
    await this.getSearchBoardTableList();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.deviceWidth = window.innerWidth;
      if (this.deviceWidth < 768) {
        this.titleMaxLength = 12;
      }
      if (this.deviceWidth >= 768) {
        this.titleMaxLength = 30;
      }
      if (this.deviceWidth >= 1024) {
        this.titleMaxLength = 40;
      }
    },
    async getSearchBoardTableList() {
      try {
        const { data } = await axiosInstance.get("/private/board/board-list", {
          params: {
            categoryId: this.categoryData.categoryId,
            searchNm: this.searchNm,
            searchType: this.searchType
          }
        });
        this.pageBoardList = data;
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    showBoardDetail(boardItem) {
      if (boardItem.title === "") return false;
      sessionStorage.setItem("boardDetail", JSON.stringify(boardItem));
      router.push({name: "BoardDetail", params: {boardId: boardItem.boardId}});
    },
    routePage(type) {
      if (type === "write") {
        router.push({name: "BoardWrite", params: {categoryId: this.categoryData.categoryId}});
      }
      if (type === "main") {
        router.push({name: "BoardMain"});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Board/BoardCommon.scss";
@import "@/assets/scss/Board/BoardTable.scss";
</style>